import { IPublicClientApplication } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "../authConfig";

// Recuperación de sesiones de MSAL que se quedan "enganchadas" (cuenta
// guardada que ya no vale, o un login a medias marcado como "en curso"):
// hace desde la app lo mismo que borrar a mano la caché y las cookies del
// sitio, pero solo con lo que es de MSAL y de esta app.

// Intentos de login por redirección en esta pestaña, para no entrar en un
// bucle infinito de redirecciones si Azure AD sigue fallando.
const ATTEMPTS_KEY = "aedas_login_attempts";
export const MAX_LOGIN_ATTEMPTS = 2;

export const getLoginAttempts = (): number =>
  Number(sessionStorage.getItem(ATTEMPTS_KEY) ?? 0);

export const addLoginAttempt = () =>
  sessionStorage.setItem(ATTEMPTS_KEY, String(getLoginAttempts() + 1));

export const resetLoginAttempts = () => sessionStorage.removeItem(ATTEMPTS_KEY);

const isMsalKey = (key: string) =>
  key.startsWith("msal.") ||
  key.includes(msalConfig.auth.clientId) ||
  key.includes("login.windows.net") ||
  key.includes("login.microsoftonline.com");

const clearStorage = (storage: Storage) => {
  Object.keys(storage)
    .filter(isMsalKey)
    .forEach((key) => storage.removeItem(key));
};

// Cookies de MSAL de versiones anteriores de la configuración
// (storeAuthStateInCookie), que sobreviven a cerrar la pestaña
const clearMsalCookies = () => {
  document.cookie
    .split(";")
    .map((c) => c.split("=")[0].trim())
    .filter((name) => name.startsWith("msal."))
    .forEach((name) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });
};

export const clearStaleMsalState = () => {
  clearStorage(localStorage);
  clearStorage(sessionStorage);
  clearMsalCookies();
};

// Borra la sesión guardada en este navegador y vuelve a pedir el login,
// dejando elegir cuenta (por si había otra cuenta de Microsoft guardada).
export const restartLogin = (instance: IPublicClientApplication) => {
  clearStaleMsalState();
  localStorage.removeItem("aedas_user");
  resetLoginAttempts();
  return instance.loginRedirect({ ...loginRequest, prompt: "select_account" });
};
